import {css} from '@emotion/css';

const styles = {
  link: (isDisabled: boolean): string => css`
    label: dynamicLink;
    ${isDisabled
      ? `
            pointer-events: none;
        `
      : ''}
  `,
};

export default styles;
